module.exports = __webpack_public_path__ + "static/8bf256a8bb8ecf249b57b250e1c715ee6b1da457d94128a587bac496a5b4ee31-1dc98c94890b3ae0db4abc0bad343a71.png";